import React from "react";
import Form from "react-bootstrap/Form";
import { useField } from "formik";

import "./FormGroup.css";

const Select = (props) => {
  const [field, meta] = useField(props);

  return (
    <Form.Group
      controlId={props.name}
      className="f-group"
      data-tour={props.datatour}
    >
      <Form.Label>{props.title}</Form.Label>
      <Form.Control as="select" name={props.name} onChange={field.onChange}>
        <option value="" disabled>
          {props.placeholder}
        </option>
        {props.options.map((option) => {
          return <option label={option} key={option} value={option} />;
        })}
      </Form.Control>
      {meta.error ? <div className="error">{meta.error}</div> : null}
    </Form.Group>
  );
};

export default Select;
